import styled from 'styled-components'

import type { ColorwayProps } from './types'

export const Container = styled.div<{ direction: ColorwayProps['direction'] }>`
  display: ${({ direction }) => (direction === 'horizontal' ? 'flex' : 'inline-flex')};
  align-items: flex-start;
  gap: var(--space-300);
  flex-wrap: wrap;
  flex-direction: ${({ direction }) => (direction === 'horizontal' ? 'row' : 'column')};
`

export const Backdrop = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: var(--bg-secondary);

  position: absolute;
  z-index: -1;
`
export const TooltipColorName = styled.div`
  color: var(--text-primary-invert);
  text-align: center;
  white-space: nowrap;

  font-size: var(--font-size-300);
  font-style: normal;
  font-weight: var(--font-weight-regular);
`

export const TooltipDragAndDropDescription = styled.div`
  color: var(--text-secondary-invert);
  text-align: center;
  white-space: nowrap;

  font-size: var(--font-size-200);
  font-style: normal;
  font-weight: var(--font-weight-regular);
`

export const TooltipContentForDraggable = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
